import {Injectable} from '@angular/core';

declare var app;

@Injectable()
export class NotificationsService {

  constructor() {
  }

  show(content: string) {
    app.toast(content);
  }
}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/services/notifications.service.ts